import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Page, Toast, Card } from '@shopify/polaris';

import { useFetchBrand } from 'hooks';

import PageLoading from '../PageLoading';
import NewWayImage from 'img/the_new_way.svg';

const Container = styled.div`
  width: 80%;
  margin: auto;
  max-width: 1200px;

  ${({ isConnected }) =>
    !isConnected &&
    `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 40px;
    max-width: 680px;
    font-family: Inter, 'Open Sans', sans-serif;
  `};
`;

const CardWrapper = styled.div`
  padding: 40px;
`;

const EmotiveLink = styled.a`
  align-items: center;
  width: 100%;
  background: #3961e6;
  padding: 14px;
  border-radius: 6px;
  color: white;
  border: none;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  text-decoration: none;
`;

const WelcomeHeader = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  color: #0e0c31;
  text-align: center;
  padding-bottom: 8px;
`;

const WelcomeSubtext = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  padding-bottom: 24px;
`;

const GetStarted = styled.div`
  font-size: 25.4px;
  font-weight: 600;
  padding-top: 8px;
  color: #4a495a;
  padding-top: 8px;
  line-height: 30px;
`;

const GetStartedHeader = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 13px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6f6f7b;
  padding-top: 40px;
`;

const GetStartedContainer = styled.div`
  text-align: center;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const EngageCustomers = styled.div`
  padding-top: 16px;
  color: #0e0c31;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
`;

const DemoLink = styled.a`
  color: #007bff;
  text-decoration: none;
`;

const CoverImage = styled.img`
  width: 100%;
  height: 80%;
  object-fit: cover;
  object-position: center;
`;

const HelpCenterLink = styled.a`
  position: absolute;
  top: 18px;
  right: 28px;
  text-decoration: none;
`;

const DEMO_LINK =
  'https://emotive.io/100-dollars-demo?nfc=true&utm_source=ShopifyPlusPartnerDirectory&utm_medium=shopify_appstore&utm_campaign=PLG';

const LOGIN_LINK = 'https://www.emotiveapp.co/dashboard';

const Embedded = () => {
  const [error, setError] = useState(null);

  const { data, loading, error: apiError } = useFetchBrand();
  const [isConnected, setIsConnected] = useState(data?.is_connected ?? false);

  useEffect(() => {
    setError(apiError);
  }, [apiError]);

  useEffect(() => {
    if (data) setIsConnected(data?.is_connected ?? false);
  }, [data]);

  if (loading) return <PageLoading />;

  return (
    <Container isConnected={isConnected}>
      <HelpCenterLink
        href="https://emotive.zendesk.com/hc/en-us"
        rel="noreferrer"
        target="_blank"
      >
        Help Center
      </HelpCenterLink>

      <Page fullWidth>
          <>
            <WelcomeHeader>Welcome to Emotive!</WelcomeHeader>

            <WelcomeSubtext>Your next best revenue channel</WelcomeSubtext>

            <Card>
              <CardWrapper>
                <CoverImage alt="" src={NewWayImage} />

                <GetStartedHeader>
                  Conversational SMS Marketing
                </GetStartedHeader>

                <GetStarted>Grow faster with SMS marketing</GetStarted>

                <EngageCustomers>
                  Engage your customers and drive more revenue through Emotive
                  SMS marketing. It's easy to use, simple to set up, and free to
                  try.
                </EngageCustomers>

                <GetStartedContainer>
                  <EmotiveLink href={LOGIN_LINK} target="_blank">
                    Open Emotive
                  </EmotiveLink>

                  <p>
                    Don't have an Emotive Account,{' '}
                    <DemoLink href={DEMO_LINK} target="_blank">
                      Book a Demo <span>&#8594;</span>
                    </DemoLink>
                  </p>
                </GetStartedContainer>
              </CardWrapper>
            </Card>
          </>
      </Page>

      {error && (
        <Toast content={error} error onDismiss={() => setError(null)} />
      )}
    </Container>
  );
};

export default Embedded;
